
export const constructDefaultNavStructure = (i18n: any) => {
  return {
    header: {
      theme: "app",
      collapseMenus: [true, false],
      brand: {
        label: null,
        brandText: null,
        image: null,
        width: 30,
        height: 30
      },
      menus: [
        [
          { label: i18n.globalNav.account.profile, href: "#user-menu-link-1" },
          { label: i18n.globalNav.account.myEsri, href: "#user-menu-link-2" },
          { label: i18n.globalNav.account.training, href: "#user-menu-link-3" },
          { label: i18n.globalNav.account.community, href: "#user-menu-link-4" }
        ]
      ],
      account: {
        label: i18n.globalNav.account.label,
        controls: {
          signin: i18n.globalNav.account.signin,
          signout: i18n.globalNav.account.signout,
          switch: i18n.globalNav.account.switch
        },
        menus: [
          { label: "profile & settings", href: "./user.html" },
          { label: "my esri", href: "#", data: { agoMethod: "goMyesri" } },
          { label: "training", href: "#", data: { agoMethod: "goTraining" } },
          {
            label: "community & forums",
            href: "#",
            data: { agoMethod: "goEsriCommunity" }
          },
          { label: "help", href: "http://doc.arcgis.com/en/arcgis-online/" }
        ],
        user: {}
      },
      notifications: {
        label: i18n.globalNav.notifications.label,
        dismissAllLabel: i18n.globalNav.notifications.dismissAllLabel,
        dismissLabel: i18n.globalNav.notifications.dismissLabel,
        clearAllLabel: i18n.globalNav.notifications.clearAllLabel,
        emptyMessage: {
          image: {
            path: [
              "M15.5 1A14.5 14.5 0 1 0 30 15.5 14.5 14.5 0 0 0 15.5 1zm0 28.1a13.6 13.6 0 1 1 13.6-13.6 13.615 13.615 0 0 1-13.6 13.6zM8.581 17.276l.637-.636 3.288 3.098 10.073-9.92.637.637-10.71 10.556z"
            ],
            viewBox: "0 0 32 32"
          },
          text: i18n.globalNav.notifications.emptyMessageLabel
        },
        messages: []
      }
    }
  }
};
